<div class="message-templates-dialog">
    <div class="dialog-header">
      <span *ngIf="messageType === 'Email'">Message templates</span>
      <span *ngIf="messageType === 'Reminder'">Reminder templates</span>
    </div>
    <div class="import-dialog-content">
      <fieldset class="subject-fieldset">
        <legend class="subject-legend">Subject</legend>
        <div class="subject-input-wrapper">
          <input
            #subjectInputField
            type="text"
            [formControl]="msgTemplateSubjectFormControl"
            (blur)="onBlurSubjectName($event)"
            (mousedown)="onSubjectMousedown($event, subjectInputField)"
            (dblclick)="onSubjectDblclick($event, subjectInputField)"
            (keydown)="onSubjectKeydown($event)"
            maxlength="255"
            minlength="5"
            class="subject-input"
          />
        </div>
      </fieldset>
      <dl-rich-text-document style="margin-top: 27px;" [jsonTextItem]="textDoc" [showInEditor]="" (jsonTextReturn)="setRTETextadd($event)"></dl-rich-text-document>
    </div>
    <div class="import-dialog-actions">
      <owc-button class="cancel-button" (click)="closeDialog.emit()">
        Cancel
      </owc-button>
      <owc-button color="primary" (click)="updateMsgTemplate()">
        Save
      </owc-button>
    </div>
  </div>
  